import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Thing, WithContext } from 'src/_utility/schema';

@Injectable({
  providedIn: 'root'
})
export class LdJsonService {

  static scripts = new BehaviorSubject<{ [key in string]: WithContext<Thing>[] }>({});

  get observeScripts() { return LdJsonService.scripts.asObservable(); }

  addScript(componentName: string, jsons: WithContext<Thing>[]) {
    const s = LdJsonService.scripts.value;
    s[componentName] = jsons;
    LdJsonService.scripts.next(s);
  }



  /**
   * Remove all the scripts but the one indicated by componentName.
   * If jsons != null assign that jsons to componentName
   */
  removeAllBut(componentName: string, jsons: WithContext<Thing>[] = []) {

    const s = jsons.length == 0 ? LdJsonService.scripts.value : {};
    if (jsons.length == 0) {
      Object.keys(s).forEach(key => {
        if (key !== componentName) {
          delete s[key];
        }
      })
    } else {
      s[componentName] = jsons;
    }

    LdJsonService.scripts.next(s);
  }
  /**
   * Remove all the scripts but the one indicated by componentName.
   * If jsons != null assign that jsons to componentName
   */
  removeByid(id: string,) {

    const s = LdJsonService.scripts.value;
    delete s[id];

    LdJsonService.scripts.next(s);
  }
  private scripts: any[] = [];
  private renderer2: Renderer2;
  constructor(
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private injDocument: Document,
  ) {
    this.renderer2 = rendererFactory.createRenderer(null, null);

    this.observeScripts.subscribe(scripts => {
      this.scripts.forEach(s => {
        this.renderer2.removeChild(this.injDocument.head, s);
      })
      this.scripts = [];

      Object.keys(scripts).forEach(key => {

        scripts[key].forEach(json => {
          const script = this.renderer2.createElement('script');
          script.type = `application/ld+json`;
          script.text = JSON.stringify(json, null, 2);

          this.renderer2.appendChild(this.injDocument.head, script);
          this.scripts.push(script);
        });

      })

    })
  }
}
